import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import BlueButton from '../buttons/BlueButton';
import SilverButton from '../buttons/SilverButton';
import DestructiveButton from '../buttons/DestructiveButton';
import config from '../../config';
import {generalModalStyles} from '../../utils/General';
import Modal from '../ui/Modal';
import SaveIcon from '../../assets/icons/SaveIcon';
import DeleteIcon from '../../assets/icons/DeleteIcon';
import './ConfirmationModal.css';

const ConfirmationModal = ({
                               isOpen,
                               onClose,
                               onConfirm,
                               message,
                               secondaryText,
                               loading = false,
                               variant = 'default',
                               icon,
                           }) => {
    const isDelete = variant === 'delete';
    const resolvedSecondaryText = secondaryText || (isDelete
        ? <Translate text="deleteConfirmationSecondaryText"/>
        : null);
    const headerIcon = icon || (isDelete
        ? <DeleteIcon width={20} height={20} stroke="var(--ds-error-primary)"/>
        : <SaveIcon width={20} height={20} fill="var(--ds-fg-brand-primary)"/>);
    const confirmButton = isDelete ? (
        <DestructiveButton type="button" height="40px" disabled={loading} loading={loading}
                           styles={{flex: '1 1 0'}} onClick={onConfirm}>
            <Translate text="delete"/>
        </DestructiveButton>
    ) : (
        <BlueButton type="button" height="40px" disabled={loading} loading={loading}
                    styles={{flex: '1 1 0'}} onClick={onConfirm}>
            <Translate text="confirm"/>
        </BlueButton>
    );

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            style={{
                ...generalModalStyles.confirmModalStyles,
                content: {
                    ...generalModalStyles.confirmModalStyles.content,
                    width: '400px',
                    maxWidth: 'calc(100vw - 32px)',
                },
            }}
            isOpen={isOpen}
            onRequestClose={loading ? undefined : onClose}
            headerIcon={headerIcon}
            footer={<React.Fragment>
                <SilverButton type="button" height="40px" disabled={loading}
                              styles={{flex: '1 1 0'}} onClick={onClose}>
                    <Translate text="cancel"/>
                </SilverButton>
                {confirmButton}
            </React.Fragment>}
        >
            <div className="confirmation-modal__content">
                <div className="confirmation-modal__main-text">{message}</div>
                {resolvedSecondaryText && (
                    <div className="confirmation-modal__secondary-text">{resolvedSecondaryText}</div>
                )}
            </div>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.node.isRequired,
    secondaryText: PropTypes.node,
    loading: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'delete']),
    icon: PropTypes.node,
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components-new/modals/ConfirmationModal.jsx